import { createSlice } from "@reduxjs/toolkit";
import { getGlobalState } from "../../utils/getGlobalState.js";

const initialState = {
  ...getGlobalState(),
  locale: localStorage.getItem("locale") || "en",
  userLogin: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserItem: (state, action) => {
      Object.assign(state, action.payload);
    },
    setUserLogin: (state, action) => {
      state.userLogin = action.payload;
    },
    updateUserLogin: (state, action) => {
      if (state.userLogin) {
        if (action.payload?.name) {
          state.userLogin.name = action.payload.name;
        }
        if (action.payload?.sex) {
          state.userLogin.sex = action.payload.sex;
        }
        if (action.payload?.dateOfBirth) {
          state.userLogin.dateOfBirth = new Date(action.payload.dateOfBirth)
            .toISOString()
            .split("T")[0];
        }
      }
    },
    clearUserLogin: (state) => {
      state.userLogin = null;
    },
  },
});
export const { setUserLogin, clearUserLogin, setUserItem, updateUserLogin } =
  userSlice.actions;
export default userSlice;
